import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  production: false,
  authority: 'http://172.20.192.238/api/v1/',
  authority_short: '/api/v1/',
  paypal_client_id:
    'ARK3liSSy0FT4WzX0BRrAuG1Hh26VM3Z-84R8HMdwqNFq8NSG2yuf1VSd1TWxGpC0CCsZAYGm7bAtzLB',
};
